import { Component, HostListener, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent {
  showNeedHelp = false;

  constructor(
    private translate: TranslateService,
    private elementRef: ElementRef
  ) {}

  changeLanguage(lang: string): void {
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
  }

  toggleNeedHelp(event: Event) {
    event.stopPropagation();
    this.showNeedHelp = !this.showNeedHelp;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);

    if (!clickedInside) {
      this.showNeedHelp = false;
    }
  }
}
